/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { css, jsx } from '@compiled/react';

import { token } from '@atlaskit/tokens';

const svgStyles = css({
	fill: token('elevation.surface'),
	overflow: 'hidden',
	pointerEvents: 'none',
});

type RoundCornerProps = {
	color?: string;
	label?: string;
};

export const RoundCornerIcon = ({ color, label }: RoundCornerProps): JSX.Element => {
	return (
		<svg
			viewBox="0 0 24 24"
			height="16px"
			width="16px"
			style={{
				color: color ?? token('color.text'),
			}}
			css={svgStyles}
			aria-label={label || undefined}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M8.5714 0H6.8571C3.07 0 0 3.07 0 6.8571V8.5714H2.5714V6.8571C2.5714 4.4902 4.4902 2.5714 6.8571 2.5714H8.5714V0ZM8.5714 21.4286H6.8571C4.4902 21.4286 2.5714 19.5098 2.5714 17.1429V15.4286H0V17.1429C0 20.9299 3.07 24 6.8571 24H8.5714V21.4286ZM15.4286 24V21.4286H17.1429C19.5098 21.4286 21.4286 19.5098 21.4286 17.1429V15.4286H24V17.1429C24 20.9299 20.9299 24 17.1429 24H15.4286ZM15.4286 2.5714V0H17.1429C20.9299 0 24 3.07 24 6.8571V8.5714H21.4286V6.8571C21.4286 4.4902 19.5098 2.5714 17.1429 2.5714H15.4286Z"
				fill="currentColor"
			/>
		</svg>
	);
};
